var version = {
    "name":      "dativery",
    "buildDateCode": "20260828-115456",
    "buildDate": "Fri Aug 28 2026 11:54:56 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260828-115456",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;